import { flow } from 'fp-ts/function';
import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch, PaymentCard } from '@mews-commander/types';
import { withScopeContext } from '@mews/framework';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getPaymentCard, shouldShowSurcharge } from '../../../../selectors';
import { openChargeAndCloseConfirmationDialog } from '../ChargeAndCloseConfirmationDialog';

interface StateProps {
    paymentCard: PaymentCard;
    shouldShowSurcharge: boolean;
    enterpriseId: string;
}

interface DispatchProps {
    handlePaymentCardClick: (creditCardId: string) => void;
}

interface OwnProps {
    paymentCardId: string;
    billId: string;
    scope: string;
    disabled: boolean;
}

const connectPaymentCardOption = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        paymentCard: (state: ApplicationState, { paymentCardId }: OwnProps) =>
            getPaymentCard(state, { id: paymentCardId }),
        shouldShowSurcharge: (state: ApplicationState, { paymentCardId }: OwnProps) => {
            const enterpriseId = getCurrentEnterpriseId();
            // @ts-expect-error
            return shouldShowSurcharge(state, { id: paymentCardId, enterpriseId });
        },
        enterpriseId: () => getCurrentEnterpriseId(),
    }),
    (dispatch: CommanderThunkDispatch, { billId, scope }) => ({
        handlePaymentCardClick: (cardId: string) =>
            dispatch(openChargeAndCloseConfirmationDialog({ cardId, billId, scope })),
    })
);

export const connectScopedPaymentCardOption = flow<
    $TSFixMe,
    ComponentType<OwnProps>,
    ComponentType<Omit<OwnProps, 'scope'>>
>(connectPaymentCardOption, withScopeContext);
